module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "login-register-wrapper"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "component-heading login-heading"
  }, [_vm._v("ZALOGUJ SIĘ ABY UMÓWIĆ WIZYTĘ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "input-default input-username",
    attrs: {
      "type": "text",
      "placeholder": "Wpisz login..."
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "input-default input-password",
    attrs: {
      "type": "password",
      "placeholder": "Wpisz hasło..."
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "credentials-submit-wrapper"
  }, [_c('div', {
    staticClass: "password-recovery-box"
  }, [_c('div', [_vm._v("Nie pamiętasz hasła?")]), _vm._v(" "), _c('router-link', {
    staticClass: "password-recovery-link",
    attrs: {
      "to": {
        name: 'password-recovery'
      }
    }
  }, [_vm._v("\n                        Odzyskaj hasło\n                    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-solid-blue btn-component",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("ZALOGUJ SIĘ")])])]), _vm._v(" "), _c('div', {
    staticClass: "register-box"
  }, [_c('div', {
    staticClass: "component-heading register-heading"
  }, [_vm._v("ZAREJESTRUJ SIĘ")]), _vm._v(" "), _c('p', {
    staticClass: "register-prompt"
  }, [_vm._v(" Dzięki rejestracji w sytemie dr100 będziesz mógł wygodnie umawiać się\n                on-line na wizyty stomatologiczne oraz będziesz miał wgląd w historię swoich danych medycznych")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-solid-green btn-component btn-register",
    attrs: {
      "to": {
        name: 'registration'
      },
      "tag": "button"
    }
  }, [_vm._v("REJESTRACJA")])], 1)]), _vm._v(" "), (_vm.freeTerm) ? _c('free-term', {
    attrs: {
      "free-term": _vm.freeTerm,
      "type": _vm.TYPES.CHOSEN
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59dd5f72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 206
// module chunks = 0